import React from "react";
var ChevronDownSvg = function ChevronDownSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9992 6.58578L23.4134 8L11.9997 19.4137L0.585938 8L2.00015 6.58578L11.9992 16.585L21.9992 6.58578Z",
    fill: "currentColor"
  }));
};
ChevronDownSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronLeftSvg = function ChevronLeftSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4134 21.9993L15.9992 23.4135L4.58545 11.9998L15.9992 0.586029L17.4134 2.00024L7.41417 11.9992L17.4134 21.9993Z",
    fill: "currentColor"
  }));
};
ChevronLeftSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronRightSvg = function ChevronRightSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58545 2.00024L7.99966 0.586029L19.4134 11.9998L7.99966 23.4135L6.58545 21.9993L16.5847 12.0003L6.58545 2.00024Z",
    fill: "currentColor"
  }));
};
ChevronRightSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronUpSvg = function ChevronUpSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99985 17.4137L0.585636 15.9995L11.9994 4.58579L23.4131 15.9995L21.9989 17.4137L11.9999 7.41451L1.99985 17.4137Z",
    fill: "currentColor"
  }));
};
ChevronUpSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CloseSvg = function CloseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0002 0.585785L23.4144 2L13.4139 11.9998L23.4144 22L22.0002 23.4142L11.9999 13.4138L2.00015 23.4142L0.585938 22L10.5859 11.9998L0.585938 2L2.00015 0.585785L11.9999 10.5858L22.0002 0.585785Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
CloseSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HomeSvg = function HomeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 21.9998V15H10V21.9998L2 22V12.4142C2 11.9427 2.16649 11.4884 2.46691 11.1298L2.58579 11L12 1.58578L21.4142 11C21.7476 11.3334 21.9511 11.7724 21.9923 12.2384L22 12.4142V22L14 21.9998ZM12 4.414L4 12.4142V20L8 19.9998V15C8 13.9456 8.81588 13.0818 9.85074 13.0055L10 13H14C15.0544 13 15.9182 13.8159 15.9945 14.8507L16 15V19.9998L20 20V12.4142L12 4.414Z",
    fill: "currentColor"
  }));
};
HomeSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var InformationSvg = function InformationSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 2.83333C6.93739 2.83333 2.83333 6.93739 2.83333 12C2.83333 17.0626 6.93739 21.1667 12 21.1667C17.0626 21.1667 21.1667 17.0626 21.1667 12C21.1667 6.93739 17.0626 2.83333 12 2.83333ZM13 10V18H11V10H13ZM12 6C12.5128 6 12.9355 6.38272 12.9933 6.88267L13 7C13 7.51284 12.6173 7.93551 12.1173 7.99327L12 8C11.4477 8 11 7.55614 11 7C11 6.48716 11.3827 6.06449 11.8827 6.00673L12 6Z",
    fill: "currentColor"
  }));
};
InformationSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PadlockSvg = function PadlockSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11V7C16 4.8578 14.316 3.10892 12.1996 3.0049L12 3C9.8578 3 8.10892 4.68397 8.0049 6.80036L8 7V11H16ZM18 13H6V21H18V13ZM12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16ZM6 7C6 3.68629 8.68629 1 12 1C15.2384 1 17.8776 3.56557 17.9959 6.77506L18 7V11L18.1493 11.0055C19.1841 11.0818 20 11.9456 20 13V21C20 22.1046 19.1046 23 18 23H6C4.89543 23 4 22.1046 4 21V13C4 11.8954 4.89543 11 6 11V7Z",
    fill: "currentColor"
  }));
};
PadlockSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MenuSvg = function MenuSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 18V20H2V18H22ZM22 11V13H2V11H22ZM22 4V6H2V4H22Z",
    fill: "currentColor"
  }));
};
MenuSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MinusSvg = function MinusSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 11V13H0V11H24Z",
    fill: "currentColor"
  }));
};
MinusSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var NegativeSvg = function NegativeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 2.83333C6.93739 2.83333 2.83333 6.93739 2.83333 12C2.83333 17.0626 6.93739 21.1667 12 21.1667C17.0626 21.1667 21.1667 17.0626 21.1667 12C21.1667 6.93739 17.0626 2.83333 12 2.83333ZM12 16C12.5128 16 12.9355 16.3827 12.9933 16.8827L13 17C13 17.5128 12.6173 17.9355 12.1173 17.9933L12 18C11.4872 18 11.0645 17.6173 11.0067 17.1173L11 17C11 16.4872 11.3827 16.0645 11.8827 16.0067L12 16ZM13 6V14H11V6H13Z",
    fill: "currentColor"
  }));
};
NegativeSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PlusSvg = function PlusSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0V11H24V13H13V24H11V13H0V11H11V0H13Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
PlusSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PositiveSvg = function PositiveSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 2.83333C6.93739 2.83333 2.83333 6.93739 2.83333 12C2.83333 17.0626 6.93739 21.1667 12 21.1667C17.0626 21.1667 21.1667 17.0626 21.1667 12C21.1667 6.93739 17.0626 2.83333 12 2.83333ZM17 7L18.4358 8.39229L8.99063 18.1326L5 14.0173L6.4358 12.625L8.9899 15.2591L17 7Z",
    fill: "currentColor"
  }));
};
PositiveSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SearchSvg = function SearchSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19C12.125 19 14.078 18.2635 15.6177 17.0319L21.364 22.7782L22.7782 21.364L17.0319 15.6177C18.2635 14.078 19 12.125 19 10C19 5.02944 14.9706 1 10 1ZM10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3Z",
    fill: "currentColor"
  }));
};
SearchSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var TickSvg = function TickSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.293 3.29289L23.7072 4.70711L7.00008 21.4142L0.292969 14.7071L1.70718 13.2929L7.00008 18.585L22.293 3.29289Z",
    fill: "currentColor"
  }));
};
TickSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var WarningSvg = function WarningSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2953 2.08977C10.813 1.07222 11.9959 0.701023 12.9373 1.26067C13.2606 1.45284 13.5266 1.74038 13.7044 2.08977L22.7588 19.8839C23.2766 20.9015 22.9332 22.1801 21.9918 22.7397C21.7046 22.9105 21.3821 23 21.0543 23H2.94537C1.87097 23 1 22.0586 1 20.8973C1 20.543 1.08283 20.1944 1.24081 19.8839L10.2953 2.08977ZM12.0022 3L2.99567 21.0061L21.0028 20.9995L12.0022 3ZM12 17C12.5128 17 12.9355 17.3827 12.9933 17.8827L13 18C13 18.5128 12.6173 18.9355 12.1173 18.9933L12 19C11.4477 19 11 18.5561 11 18C11 17.4872 11.3827 17.0645 11.8827 17.0067L12 17ZM13 9V15H11V9H13Z",
    fill: "currentColor"
  }));
};
WarningSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var icons = {
  chevron_down: ChevronDownSvg,
  chevron_left: ChevronLeftSvg,
  chevron_right: ChevronRightSvg,
  chevron_up: ChevronUpSvg,
  close: CloseSvg,
  cross: CloseSvg,
  home: HomeSvg,
  information: InformationSvg,
  menu: MenuSvg,
  minus: MinusSvg,
  negative: NegativeSvg,
  padlock: PadlockSvg,
  plus: PlusSvg,
  positive: PositiveSvg,
  search: SearchSvg,
  tick: TickSvg,
  warning: WarningSvg
};
export default icons;